import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-innovative-school-strategies',
  imports: [PillarPagesTemp],
  templateUrl: './innovative-school-strategies.html',
  styleUrl: './innovative-school-strategies.scss',
})
export class InnovativeSchoolStrategies {

}
